import { Button as ChakraButton } from "@chakra-ui/react";
import type { ComponentPropsWithRef } from "react";

export type ButtonProps = ComponentPropsWithRef<typeof ChakraButton>;

export function Button(props: ButtonProps) {
  return <ChakraButton {...props} />;
}
